import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {SelectWbAccountData, UploadExcelDialogData, UploadExcelParams} from "./types/upload-excel-modal.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {UploadExcelService} from "./services/upload-excel.service";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/input";
import {
  DelayedFileUploadCardComponent
} from "../../../../shared/components/ui/delayed-file-upload-card/delayed-file-upload-card.component";
import {EXCEL_EXTENSIONS} from "./configs/upload-excel-modal-config";
import {FilesService} from "../../../services/files.service";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";
import { MatOption, MatSelect } from "@angular/material/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-upload-excel-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatLabel,
    DelayedFileUploadCardComponent,
    LoaderComponent,
    MatSelect,
    FormsModule,
    MatOption
  ],
  templateUrl: './upload-excel-modal.component.html',
  styleUrl: './upload-excel-modal.component.scss'
})
export class UploadExcelModalComponent extends BaseModalComponent {
  private uploadExcelDialogData = inject<UploadExcelDialogData>(MAT_DIALOG_DATA);
  private uploadExcelService: UploadExcelService = inject(UploadExcelService);
  private filesService: FilesService = inject(FilesService);

  public readonly excelExtensions = EXCEL_EXTENSIONS;
  public account: string = '';
  public wbAccounts: Array<SelectWbAccountData> = [];
  private selectedFile: File | null = null;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await this.getSelectDataWbAccounts();
  }

  public filesSelectedForUpload(files: Array<File>): void {
    this.selectedFile = files[0];
  }

  public async handleUploadExcel(): Promise<void> {
    if (!this.account) {
      this.errorService.showErrorMessage('Введите аккаунт WB!')
      return;
    }

    if (!this.selectedFile) {
      this.errorService.showErrorMessage('Загрузите файл!')
      return;
    }

    const formData = this.filesService.createFormData({
      file: this.selectedFile,
      fileType: 'file'
    });

    const uploadExcelParams: UploadExcelParams = {
      file: formData,
      account: this.account,
      path: this.uploadExcelDialogData.parentUrl,
      fileName: this.selectedFile.name
    };

    this.loadingService.setIsLoadingState(true);
    await this.uploadExcelService.uploadExcel(uploadExcelParams)
      .then(() => {
        this.snackbarService.showMessage({
          message: 'Файл успешно загружен!',
          type: 'success'
        });
        this.closeDialog('success');
      })
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private async getSelectDataWbAccounts(): Promise<void> {
    this.wbAccounts = await this.uploadExcelService.getSelectDataWbAccounts(this.uploadExcelDialogData.parentUrl).catch(() => []);
  }
}
